import React, { useState } from 'react';

import styled from '@emotion/styled';

import { ChevronDown } from '../Icons/ChevronDown';
import { ChevronUp } from '../Icons/ChevronUp';

interface CollapsableBundleControlProps {
  isCollapse: boolean;
  setIsCollapse: (...args: any) => void;
}

const CollapsableBundleControl: React.FC<CollapsableBundleControlProps> = ({
  isCollapse,
  setIsCollapse,
}) => {
  return (
    <Control onClick={() => setIsCollapse(!isCollapse)}>
      {isCollapse ? <ChevronUp /> : <ChevronDown />}
    </Control>
  );
};

const Control = styled.div`
  display: flex;
  cursor: pointer;
`;

interface BundleCollapseGroupProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
}

interface ContentProps {
  isCollapse: boolean;
}

const BundleCollapseGroup: React.FC<BundleCollapseGroupProps> = ({
  children,
  title,
}) => {
  const [isCollapse, setIsCollapse] = useState(false);
  return (
    <Container>
      <LabelSection>
        {title && <Label>{title}</Label>}

        <CollapsableBundleControl
          isCollapse={isCollapse}
          setIsCollapse={setIsCollapse}
        />
      </LabelSection>
      <Content isCollapse={isCollapse}>{children}</Content>
    </Container>
  );
};

export default BundleCollapseGroup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  /* border: 1px solid red; */

  &.collapse {
    gap: 0px;
  }
`;

const LabelSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 12px;

  border: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

interface LabelProps {
  border?: boolean;
  rmHeaderBorder?: boolean;
  continuousView?: boolean;
  bgColor?: string;
  firstColumnOffset?: string;
}

const Label = styled.div<LabelProps>`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrayText};
  width: fit-content;
  user-select: none;

  @media (max-width: 884px) {
    font-size: 16px;
  }
`;

const Content = styled.div<ContentProps>`
  display: ${({ isCollapse }) => (isCollapse ? 'block' : 'none')};
`;
